/* ==========================================================================
   Mobil-PDP, kollektionsfilter och mobilmeny - Corlin
   Skapad 2026-09-03, flyttad hit 2026-09-04. Sex ingrepp, alla additiva.
   Inget i temats egna filer andras. Aterstallning: ta bort de fyra raderna
   i layout/theme.liquid.

   1) Scrollindikator flush med bildens underkant - en tunn list dar en
      morkare tumme glider i takt med att man bladdrar. Slidern ar temats
      egen native scroll-snap-losning; skriptet lyssnar bara pa dess scroll.
   2) Brodsmulorna flyttas upp ovanfor bilden i mobil, tillbaka pa desktop.
   3) Description-dragspelet stangs, sa att alla fem rubriker syns direkt.
   4) Produktantal i kollektionssidans filterrad. Antalet kommer fran Liquid
      via en meta-tagg i layout/theme.liquid; ordet valjs efter sprak har.
   5) Mobilmenyns pilar blir plustecken, sa att de matchar dragspelen i
      resten av sajten.
   6) Etiketter och fragor i dragspelen satts i fetstil.
   ========================================================================== */
(function () {
  var MOBILE = '(max-width: 749px)';

  function onBreakpointChange(mq, handler) {
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else if (mq.addListener) mq.addListener(handler);
  }

  /* --- 1. Scrollindikator ------------------------------------------------ */
  function initScrollbar(images) {
    var track = images.querySelector('.product__slides');
    if (!track) return;

    var slides = track.querySelectorAll('.product__slide');
    if (slides.length < 2) return;
    if (images.querySelector('.pdp-test-scrollbar')) return;

    var bar = document.createElement('div');
    bar.className = 'pdp-test-scrollbar';
    bar.setAttribute('aria-hidden', 'true');

    var thumb = document.createElement('span');
    thumb.className = 'pdp-test-scrollbar__thumb';
    bar.appendChild(thumb);

    track.insertAdjacentElement('afterend', bar);

    var ratio = 0;

    /* Matningen gors bara vid start och resize. Under scroll skrivs bara
       left, som ar ren aritmetik - ingen layout-berakning tvingas fram. */
    function measure() {
      var full = track.scrollWidth;
      if (!full) return;

      ratio = 100 / full;
      thumb.style.width = (track.clientWidth * ratio) + '%';
      update();
    }

    function update() {
      if (!ratio) return;
      thumb.style.left = (track.scrollLeft * ratio) + '%';
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measure);

    measure();
  }

  /* --- 2. Brodsmulor ovanfor bilden -------------------------------------- */
  function initBreadcrumbs(page) {
    var images = page.querySelector('.product__images');
    var crumbs = page.querySelector('.product__breadcrumbs');
    if (!images || !crumbs) return;

    var home = crumbs.parentNode;
    var anchor = crumbs.nextSibling;
    var mq = window.matchMedia(MOBILE);

    function apply() {
      if (mq.matches) {
        if (crumbs.parentNode !== page) {
          page.insertBefore(crumbs, images);
          crumbs.classList.add('pdp-test-breadcrumbs-top');
        }
      } else if (crumbs.parentNode === page) {
        home.insertBefore(crumbs, anchor);
        crumbs.classList.remove('pdp-test-breadcrumbs-top');
      }
    }

    /* Bade change-eventet och resize, sa att brodsmulan inte kan bli kvar pa
       fel plats om ett av dem uteblir (t.ex. vid rotation i vissa lagen). */
    onBreakpointChange(mq, apply);
    window.addEventListener('resize', apply);
    apply();
  }

  /* --- 3. Stang dragspelet som star oppet som forval --------------------- */
  function closeOpenAccordion(page) {
    /* Motsvarar att kryssa ur "oppen som forval" pa Description-blocket i
       temaeditorn. Gors har for att slippa skriva om templates/product.json.
       Trafffar bara det block som faktiskt star oppet vid laddning. */
    var details = page.querySelector('.product-accordion details[open]');
    if (!details) return;

    details.removeAttribute('open');

    /* Mallen satter inline height: auto pa kroppen nar blocket ar oppet.
       Den nollas sa att temats egen oppna/stang-animation raknar ratt. */
    var body = details.querySelector('[data-collapsible-body]');
    if (body) body.style.height = '';
  }

  /* --- 4. Produktantal i kollektionssidans filterrad --------------------- */
  var PRODUKTORD = {
    en: ['Product', 'Products'],
    sv: ['Produkt', 'Produkter'],
    no: ['Produkt', 'Produkter'],
    nb: ['Produkt', 'Produkter'],
    da: ['Produkt', 'Produkter'],
    de: ['Produkt', 'Produkte'],
    fr: ['Produit', 'Produits'],
    es: ['Producto', 'Productos'],
    it: ['Prodotto', 'Prodotti'],
    pt: ['Produto', 'Produtos']
  };

  function initCollectionCount() {
    var meta = document.querySelector('meta[name="pdp-test-collection"]');
    var nav = document.querySelector('.collection__nav');
    if (!meta || !nav) return;
    if (nav.querySelector('.pdp-test-count')) return;

    var antal = parseInt(meta.getAttribute('content'), 10);
    if (!antal) return;

    /* Sprakkoden kan vara t.ex. "sv" eller "pt-BR"; bara de tva forsta
       tecknen ar intressanta. Okant sprak faller tillbaka pa engelska. */
    var sprak = (meta.getAttribute('data-locale') || 'en').slice(0, 2).toLowerCase();
    var ord = PRODUKTORD[sprak] || PRODUKTORD.en;

    var span = document.createElement('span');
    span.className = 'pdp-test-count';
    span.textContent = antal + ' ' + (antal === 1 ? ord[0] : ord[1]);

    nav.insertBefore(span, nav.firstChild);
  }

  /* --- 5. Plus i stallet for pil i mobilmenyn ---------------------------- */
  /* Samma path som temats egen icon-plus (snippets/icon-plus.liquid), sa
     tecknet blir identiskt med det i dragspelen. Bara formen byts - klass,
     storlek och streckbredd ar temats egna. */
  var PLUS_PATH = 'M6 12h6m6 0h-6m0 0V6m0 6v6';

  function initMenuIcons() {
    /* Scopat till menyradernas chevron. Bakatpilarna i undermenyerna ar
       kvar som pilar - dar ar riktningen sjalva poangen. */
    var pilar = document.querySelectorAll('.sliderule__chevron .icon-arrow-right');

    for (var i = 0; i < pilar.length; i++) {
      var path = pilar[i].querySelector('path');
      if (path) path.setAttribute('d', PLUS_PATH);
    }
  }

  /* --- 6. Fetstil pa etiketter och fragor i dragspelen ------------------- */
  /* Texten kommer fran metafalt av typen multi_line_text_field. Shopify
     escapar all HTML i dem, sa <strong> skrivet i metafaltet skulle synas
     som bokstaver. Dragspelets textfalt i mallen tar i sin tur bara emot
     dynamiska kallor ({{ objekt | ettfilter }}) - ingen egen Liquid. Darfor
     satts fetstilen har.

     Tva monster, bada sprakoberoende:
       "Etikett: varde"  -> etiketten blir fet
       "Fraga?"          -> hela raden blir fet

     Bara stycken som innehaller <br> rors. Lopande text - Description - har
     inga radbrytningar och lamnas darmed ifred. Etiketten far vara hogst
     28 tecken och inte innehalla punkt, fragetecken eller utropstecken, sa
     att ett kolon mitt i en mening inte kan trigga regeln. */

  var ETIKETT = /^(\s*)([^:<>.?!]{1,28}):/;
  var FRAGA = /^(\s*)([^<>]+\?)(\s*)$/;
  var BR = /<br\s*\/?>/gi;

  function emphasizeLine(line) {
    if (line.indexOf('<strong') !== -1) return line;

    var fraga = line.match(FRAGA);
    if (fraga) return fraga[1] + '<strong>' + fraga[2] + '</strong>' + fraga[3];

    var etikett = line.match(ETIKETT);
    if (etikett) {
      return etikett[1] + '<strong>' + etikett[2] + ':</strong>' +
        line.slice(etikett[0].length);
    }

    return line;
  }

  function initAccordionLabels(page) {
    var paras = page.querySelectorAll('.product-accordion .accordion__content p');

    for (var i = 0; i < paras.length; i++) {
      var p = paras[i];
      if (!p.querySelector('br')) continue;

      /* metafield_tag lindar vardet i en span. Finns den skriver vi inuti
         den, sa att styckets ovriga innehall lamnas orort. */
      var host = p.querySelector('.metafield-multi_line_text_field') || p;
      var html = host.innerHTML;
      var lines = html.split(BR);
      if (lines.length < 2) continue;

      var seps = html.match(BR);
      var out = '';

      for (var j = 0; j < lines.length; j++) {
        out += emphasizeLine(lines[j]);
        if (seps && j < seps.length) out += seps[j];
      }

      if (out !== html) host.innerHTML = out;
    }
  }

  function boot() {
    var galleries = document.querySelectorAll('.product__images--mobile-slider');
    for (var i = 0; i < galleries.length; i++) initScrollbar(galleries[i]);

    initCollectionCount();
    initMenuIcons();

    var pages = document.querySelectorAll('.product__page');
    for (var j = 0; j < pages.length; j++) {
      initBreadcrumbs(pages[j]);
      closeOpenAccordion(pages[j]);
      initAccordionLabels(pages[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();